import { ApiResponse } from '@type/api'

/**
 * Извлекает данные из API-ответа с возможностью указать значение по умолчанию.
 *
 * @param apiResponse - Объект ApiResponse с данными типа T.
 * @param defaultValue - Значение по умолчанию, возвращаемое если данные отсутствуют. По умолчанию `null`.
 * @returns Данные типа T или значение по умолчанию.
 */
export function getApiResponseData<T>(apiResponse: ApiResponse<T>, defaultValue: T | undefined = undefined): T | undefined {
  if (apiResponse.data !== undefined) {
    return apiResponse.data
  }

  if (apiResponse.result !== undefined) {
    return apiResponse.result
  }

  return defaultValue
}

export default getApiResponseData
